import React, { lazy } from 'react';
const tomes = [{
  label: 'Tomo 1',
  sublabel: 'Manual de 1er Año',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777484753/ChatGPT_Image_29_abr_2026_14_44_30_nsgw9g.webp'
}, {
  label: 'Tomo 2',
  sublabel: 'Fisiología y Nutrición',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777484780/ChatGPT_Image_29_abr_2026_14_45_50_cjvf5u.webp'
}, {
  label: 'Tomo 3',
  sublabel: 'El Libro de Alimentos',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777484874/ChatGPT_Image_29_abr_2026_14_47_42_tcpufo.webp'
}, {
  label: 'Tomo 4',
  sublabel: 'Enfermedades y Dietas',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777484947/ChatGPT_Image_29_abr_2026_14_48_53_cv4whp.webp'
}, {
  label: 'Tomo 5',
  sublabel: 'Mamás y Niños',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777485050/ChatGPT_Image_29_abr_2026_14_50_17_czzbqf.webp'
}, {
  label: 'Tomo 6',
  sublabel: 'Salud Pública y Título',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777485105/ChatGPT_Image_29_abr_2026_14_51_36_iwkxyy.webp'
}];
const features = ['Todo el contenido de la carrera organizado por año y materia', 'Fórmulas de cálculo energético y nutricional listas para usar', 'Casos clínicos resueltos paso a paso por patología', 'Guías de prácticas hospitalarias y TPs listos para presentar'];
export function ProductShowcase() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(240,253,244) 100%)'
  }} data-id="element-240">
      <div className="mx-auto max-w-4xl text-center" data-id="element-241">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-green-700 border border-green-700/50 bg-green-700/5 rounded-full px-4 py-1.5" data-id="element-242">
          🏆 El sistema de estudio más completo para estudiantes de Nutrición en
          Argentina
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-green-700 m-0 mb-4" data-id="element-243">
          MEGAPACK NUTRICIÓN: CARRERA RESUELTA
        </h3>

        {/* Description */}
        <p className="max-w-2xl text-gray-800 m-0 mb-8 text-[14px]" data-id="element-244">
          <strong data-id="element-245">
            6 Tomos + 6 Bonos — Sistema de Estudio Completo — Toda la carrera
            resuelta.
          </strong>
          <br data-id="element-246" />
          +360 páginas · De Anatomía al Título · Fisiología, Bromatología y
          Dietoterapia · Casos clínicos resueltos · Guías de prácticas
          hospitalarias · Fórmulas y cálculos listos · Material de TPs y
          exámenes · 100% adaptado al plan de estudios argentino.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-247">
          <div className="grid grid-cols-6 gap-3" data-id="element-248">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-249">
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-gray-100" data-id="element-250">
                  <img src={tome.image} alt={`${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-251" />
                </div>
                <div className="text-center" data-id="element-252">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-253">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-254">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-255">
            <div className="whitespace-nowrap bg-green-700 text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" data-id="element-256">
              6 TOMOS COMPLETOS · DEL PRIMER AÑO AL TÍTULO
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-257">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 bg-green-700/5 border border-green-700/20 rounded-xl px-4 py-3 text-left" data-id="element-258">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-green-700/15 flex items-center justify-center" data-id="element-259">
                <svg className="w-3 h-3 text-green-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-260">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-261" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-262">
                {feature}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}